import { Component, Input } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-assignment-duplicate-modal",
    templateUrl: "./assignment-duplicate-modal.component.html",
})
export class AssignmentDuplicateModalComponent {
    @Input() public title: string = ""
    @Input() public assignmentData: any = { name: "" }
    @Input() saveCallback: CallableFunction = (assignmentData) => {}
    @Input() assignCallback: CallableFunction = (assignmentData) => {}

    constructor(public activeModal: ModalRef) {}
}
